import { Tag } from '@griply/types';

export const filterTagsBySearchText = (
  tags: Tag[],
  searchText: string,
): Tag[] => {
  if (!searchText) {
    return [];
  }
  const trimmedSearchText = searchText.trim().toLowerCase();

  return tags
    .filter(({ name }) => name.toLowerCase().includes(trimmedSearchText))
    .sort((a, b) => a.name.localeCompare(b.name));
};
